import React, { useState } from "react"
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@material-ui/core"

import Loader from "../components/Loading/Loader"
import useAddProjectTypeDialog from "../hooksV1/useAddProjectTypeDialog"

const AddProjectTypeDialog: React.FC = () => {
  const addProjectTypeDialog = useAddProjectTypeDialog()

  const [isLoading, setIsLoading] = useState(false)

  const handleClose = () => {
    setIsLoading(false)
    addProjectTypeDialog.onClose()
  }

  const handleCloseDialog = ( reason: "backdropClick" | "escapeKeyDown" ) => {
    if (isLoading && (reason === "backdropClick" || reason === "escapeKeyDown")) return

    handleClose()
  }

  return (
    <Dialog
      open={addProjectTypeDialog.isOpen}
      onClose={handleCloseDialog}
      fullWidth
      maxWidth="xs"
    >
      <DialogTitle>Add Project Type</DialogTitle>
      <DialogContent dividers>
        <TextField
          autoFocus
          id="name"
          label="Project Type"
          type="text"
          fullWidth
          required
        />
      </DialogContent>

      <DialogActions>
        <Button
          variant="text"
          color="primary"
          onClick={handleClose}
          disabled={isLoading}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
        >
          Add
        </Button>
      </DialogActions>

      {isLoading && <Loader open={true} />}
    </Dialog>
  )
}

export default AddProjectTypeDialog
